import { render, staticRenderFns } from "./ProjectsProposalDetails.vue?vue&type=template&id=d0b597cc&"
import script from "./ProjectsProposalDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectsProposalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports